import { render } from "./DropdownType.vue?vue&type=template&id=f63fbfc4"
import script from "./DropdownType.vue?vue&type=script&lang=js"
export * from "./DropdownType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__